import React, { useState } from 'react';
import styled from 'styled-components';
import { Input } from 'ui-components/build';
import { Button } from 'ui-components/build';
import { NamedColorsHEX } from '../util/styles';
import { useHistory, useLocation } from 'react-router-dom';

const ScSearchBox = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: 0 auto 20px auto;
  width: 100%;
`;

const ScSearch = styled(Input)`
  border-color: ${NamedColorsHEX.LightSeaGreen};
  margin-right: 5px;
  width: 90%;
`;

export const Search = ({
  goesToProducts = false,
}: {
  goesToProducts?: boolean;
}) => {
  const location = useLocation();
  const history = useHistory();

  const queryString = new URLSearchParams(location.search);

  const [term, setTerm] = useState<string>(queryString.get('term') || '');

  const onClickSearch = () => {
    const queryString = new URLSearchParams(location.search);

    if (!term.trim()) return;

    queryString.set('term', term);

    history.push(
      (goesToProducts ? '/presentes' : location.pathname) +
        '?' +
        queryString.toString()
    );
  };

  return (
    <ScSearchBox>
      <ScSearch
        value={term}
        onChange={(e) => setTerm(e.target.value)}
        placeholder="Procura..."
        onKeyDown={async (e) => {
          if (e.key === 'Enter') {
            await onClickSearch();
          }
        }}
      />
      <Button disabled={!!!term.trim()} onClick={onClickSearch}>
        Procurar
      </Button>
    </ScSearchBox>
  );
};
